<template>
  <div>
    <div class="modal fade in" @click="open = false" v-if="is_open">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="open = false">
              <i class="fas fa-times"></i>
            </button>
            <h4 class="modal-title">Search for Product to Add to This Order</h4>
          </div>
          <div class="modal-body">
            <div class="scroll">
              <div class="scroll-content">
                <product-summary
                  :finder="finder"
                  :managing="false"
                ></product-summary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ProductSummary from 'components/screens/Products';
import ActsAsModal from 'mixins/ActsAsModal';
import Product from 'components/Product';
import ProductFinder from 'src/product_finder';
import InteractsWithState from 'mixins/InteractsWithState';

export default {
  mixins: [ActsAsModal, InteractsWithState],

  props: {
    params: { type: Object, default: {} },
  },

  data() {
    return {
      finder: new ProductFinder({
        params: Object.assign({ in_stock: 1 }, this.params),
        limit: 25,
      }),
    };
  },

  watch: {
    'state.product'(product) {
      if (product.id) {
        this.open = false;
      }
    },

    is_open(v) {
      if (v) {
        this.finder.search(v);
      } else {
        this.finder.flushResults();
      }
    },
  },

  computed: {
    is_open() {
      return this.open && !this.state.product.id;
    },
  },

  components: {
    ProductSummary: _.extend({}, ProductSummary, {
      components: { Product },
    }),
  },
};
</script>

<style scoped>
.scroll {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 595px;
}
</style>



// WEBPACK FOOTER //
// ProductSearch.vue?2d0c4812